<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { type Component, ref } from 'vue'

import { userDataModel } from '@/entities/user-data'
import { useConfig } from '@/shared/config'
import { STEPS, type Steps } from '@/shared/constants'

import { AddCar } from './add-car'
import { VAuthorization } from './authorization'
import { VErrorStatus } from './error-status'
import { VNotify } from './notify'
import { SelectPayMethod } from './select-pay-method'
import { VSubscriptionManagement } from './subscription-management'
import { VVerify } from './verify'

const {
    config: { subscriptionState },
} = useConfig()

const store = userDataModel.useModel()
const { userData } = storeToRefs(store)

const currentStep = ref<Steps>(
    ((): Steps => {
        if (subscriptionState !== null) return 'notify'
        if (
            userData.value &&
            userData.value.phone &&
            userData.value.grn_list?.length &&
            userData.value.creation_date &&
            userData.value.payment_methods?.sbp
        )
            return 'sub_management'
        if (userData.value && !userData.value.grn_list) return 'addCar'
        if (userData.value && !userData.value.payment_methods?.sbp) return 'select-pay-method'
        return 'auth'
    })()
)

const components: Record<Steps, Component> = {
    [STEPS.ADD_CAR]: AddCar,
    [STEPS.AUTH]: VAuthorization,
    [STEPS.ERROR_STATUS]: VErrorStatus,
    [STEPS.NOTIFY]: VNotify,
    [STEPS.SELECT_PAY_METHOD]: SelectPayMethod,
    [STEPS.SUB_MANAGEMENT]: VSubscriptionManagement,
    [STEPS.VERIFY]: VVerify,
}
</script>

<template>
    <component
        :is="components[currentStep]"
        @goto="(value: Steps) => (currentStep = value)"
    ></component>
</template>
